import axios from 'axios';
import React, { useContext, useState} from 'react'
import NotificationContext from '../components/toasts/NotificationContext';
import { constants } from '../constants';

const Register =  (props) => {

  const emailRegister = props.emailRegister;
  const tokenRegister = props.tokenRegister;
  const [newUser, setNewUser] = useState({
    name: '',
    lastname: '',
    email: '',
    celphone: '',
    identification: '',
    organization: '',
    bate_birth: '',
    password: '',
    confirmPassword: ''
  })

  const {showNotification} = useContext(NotificationContext);

  const [viewPassword, setViewPassword]= useState('password');
  const [viewConfirmPassword, setViewConfirmPassword] = useState("password")
  const [viewEye, setViewEye] = useState("far fa-eye nav-icon");
  const [viewEyeConfirm, setViewEyeConfirm] = useState("far fa-eye nav-icon");


  const {
    name,
    lastname,
    email,
    celphone,
    identification,
    organization,
    date_birth,
    password,
    confirmPassword
  } =  newUser

  newUser.email =emailRegister;
 
  const handleUser = (e) => {
    e.preventDefault();
    setNewUser({
      ...newUser,
      [e.target.name]: e.target.value,
    });
  };

  const validData = () => {
    if(name ==='' ||
      lastname === '' ||
      email=== '' ||
      identification === '' ||
      organization === '' ||
      celphone === '' ||
      date_birth === '' ||
      password === '' ||
      confirmPassword === '') {
      return false
    }else{
      return true
    }
  }

  const validPassword = () => {
    return newUser.password === newUser.confirmPassword
  }

  const createUser = async () => {
      const URL = constants.test_host + '/user/register';
      newUser.email= emailRegister;
  
      await axios.post(URL, newUser,
        {
        headers: { 'Authorization': 'Bearer ' + tokenRegister, 'Content-Type': 'application/json'}, withCredentials:true
        }
      )
      .then((resp)=>{
        window.localStorage.setItem('at', resp.data.access_token);
        if(resp.data.result){
          showNotification('success', 'Registrado correctamente.')
          setTimeout(() => {
            window.location.href = '/dashboard/user';
          }, 1000);
        }
      })
      .catch((err) => {
        console.log(err)
        if(err.response.status === 401){
          showNotification('failed', 'Su token de registro ya expiró' )
          setTimeout(() => {
            window.location.href = '/';
          }, 1500);
        }
      } )

	};

  const handleSubmit = async() => {
    if (!validData()) return  showNotification('failed', 'Todos los campos deben ser diligenciados' )
    if(!validPassword()) return showNotification('failed', 'Las contraseñas no coinciden.' )
    await createUser();  
  }

  
  const handlePass = (stateView, classPass) => {
    if(stateView==='password' && classPass === 'pass'){
      setViewPassword('text');
      setViewEye('far fa-eye-slash nav-icon')
    }
    if(stateView==='password' && classPass === 'confirm') {
      setViewConfirmPassword('text')
      setViewEyeConfirm('far fa-eye-slash nav-icon')
    }
    if(stateView==='text' && classPass === 'pass') {
      setViewPassword('password');
      setViewEye('far fa-eye nav-icon')
    }
    if(stateView==='text' && classPass === 'confirm') {
      setViewConfirmPassword('password');
      setViewEyeConfirm('far fa-eye nav-icon')
    }
  }
  return (
    <>
    <div className="row justify-content-center">
      <div className="col-lg-6">
        <div className="card shadow-lg border-0 rounded-lg mt-2">
          <div className="card-header">
            <h4 className="text-center font-weight-light my-2">
              Registro de nuevo usuario
            </h4>
          </div>
          <div className="card-body" style={{fontSize: 'small'}}>
            <form onSubmit={handleSubmit}>
              <div className="row mb-3">
                <h5>Información básica</h5>
                <hr style = {{width: '95%'}} />
                <div className="col">
                  <div className="form-floating mb-2 form-outline">
                    <input
                      className="form-control"
                      id="name"
                      type="text"
                      placeholder="Nombres"
                      name="name"
                      value={name}
                      onChange={handleUser}
                      required
                    />
                    <label htmlFor="name">Nombres</label>
                  </div>
                </div>
                <div className="col">
                  <div className="form-floating mb-3 form-outline">
                    <input
                      className="form-control"
                      id="lastname"
                      type="text"
                      placeholder="Apellidos"
                      name="lastname"
                      value={lastname}
                      onChange={handleUser}
                      required
                    />
                    <label htmlFor="lastname">Apellidos</label>
                  </div>
                </div>
              </div>

              <div className="form-floating mb-3">
                <input
                  className="form-control"
                  id="email"
                  type="email"
                  placeholder="name@example.com"
                  name="email"
                  value={emailRegister}
                  onChange={handleUser}
                  required
                  disabled
                />
                <label htmlFor="email">Email</label>
              </div>

              <div className="row mb-3">
                <div className="col">
                  <div className="form-floating mb-3 form-outline">
                    <input
                      className="form-control"
                      id="celphone"
                      type="number"
                      placeholder="Celular"
                      name="celphone"
                      value={celphone}
                      onChange={handleUser}
                      required
                    />
                    <label htmlFor="celphone">Celular</label>
                  </div>
                </div>
                <div className="col">
                  <div className="form-floating mb-3 form-outline">
                    <input
                      className="form-control"
                      id="identification"
                      type="number"
                      placeholder="Cedula"
                      name="identification"
                      value={identification}
                      onChange={handleUser}
                      required
                    />
                    <label htmlFor="identification">Cédula</label>
                  </div>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col">
                  <div className="form-floating mb-3">
                    <input
                      className="form-control"
                      id="organization"
                      type="text"
                      placeholder="Tu Marca"
                      name="organization"
                      value={organization}
                      onChange={handleUser}
                      required
                    />
                    <label htmlFor="organization">Tu Marca</label>
                  </div>
                </div>

                <div className="col">
                  <div className="form-floating mb-3 form-outline">
                    <input
                      className="form-control"
                      id="date_birth"
                      type="date"
                      placeholder="Fecha de nacimiento"
                      name="date_birth"
                      value={date_birth}
                      onChange={handleUser}
                    />
                    <label htmlFor="date_birth">Fecha de nacimiento</label>
                  </div>
                </div>
                </div>
              <div className="row mb-3">
                <div className="col">
                  <div className="form-floating mb-3 form-outline input-group">
                    <input
                      className="form-control"
                      id="password"
                      type={viewPassword}
                      placeholder="Contraseña"
                      name="password"
                      value={password}
                      onChange={handleUser}
                      required
                    />
                    <span className="input-group-text" id="basic-addon1"><i  onClick={()=> handlePass(viewPassword, 'pass')} className={viewEye} style={{cursor: 'pointer'}}></i></span>
                    <label htmlFor="password">Contraseña</label>
                  </div>
                </div>

                <div className="col">
                  <div className="form-floating mb-3 form-outline input-group">
                    <input
                      className="form-control"
                      id="confirmPassword"
                      type={viewConfirmPassword}
                      placeholder="Confirma Contraseña"
                      name="confirmPassword"
                      value={confirmPassword}
                      onChange={handleUser}
                      required
                    />
                    <span className="input-group-text" id="basic-addon1"><i onClick={() => handlePass(viewConfirmPassword, 'confirm')} className={viewEyeConfirm} style={{cursor: 'pointer'}}></i></span>
                    <label htmlFor="confirmPassword">Confirma<br />Contraseña</label>
                  </div>
                </div>

              </div>

              <div className="d-flex align-items-center justify-content-between mt-4 mb-0">
                <button className="btn btn-primary" type="button" onClick={() => handleSubmit()}>
                  Registrar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default Register
